/**
 * Return a safe href for a DB/user-supplied URL.
 * Only http:, https: and mailto: are allowed; anything else (javascript:,
 * data:, vbscript:, etc.) returns '#'. Empty input returns null.
 */
export function safeUrl(url) {
  if (!url || typeof url !== 'string') return null
  const trimmed = url.trim()
  if (!trimmed) return null
  try {
    const parsed = new URL(trimmed, window.location.origin)
    if (['http:', 'https:', 'mailto:'].includes(parsed.protocol)) return trimmed
    return '#'
  } catch {
    return '#'
  }
}

export default safeUrl
